import { IterableEmbeddedMessage } from "@/features/iterable/components/IterableEmbeddedMessage";
import { iterableStore } from "@/features/iterable/stores/iterable.store";

export const ProductDetailsInfoEmbeddedMessages = () => {
  const messages = iterableStore(state => state.pdp);

  return (
    <div className="flex flex-col space-y-2">
      {messages.map(message => (
        <IterableEmbeddedMessage
          key={message.metadata.messageId}
          message={message}
        />
      ))}
    </div>
  );
};
